// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__1lmjY","summaryTable":"Summary_summaryTable__ts_rj","total":"Summary_total__1MKh-"};